import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import JisButton from '../../components/controls/jisButton';
import CaseSearch from '../../components/core/case_search';
import JisEmptyList from '../../components/controls/emptylist';
import Pagenated from '../../components/pagenated';
import CaseDetails from '../../components/core/caseDetails';
import JisDialog from '../../components/dialog';
import JisYesNo from '../../components/controls/jisYesNo';
import JisCheckbox from '../../components/controls/jisCheckbox';
import JisDialogForm from '../../components/formdialog';
import JisPrepareTemplate from '../../components/core/preparetemplate';
import PdfViewer from '../../components/controls/pdfviewer';
import { s } from 'framer-motion/client';
import JisTabButton from '../../components/controls/jisTabButton';
import JisAlert from '../../components/jisalert';
import DeadlineBadge from '../../components/controls/deadlinebadge';
import * as Services from '../../services';
import JisPrepareTemplatePlain from '../../components/core/preparetemplate_plain';

function AuctionCompletedCases() {
     const navigate = useNavigate();
    const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const [cases, setCases] = useState([]);
    const [loading, setLoading] =useState(false);
    const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);

    const [search, setSearch]=useState(null);
    const [err,setErr]=useState('');
     const [isPreview, setIsPreview] = useState(false);
     const [count,setCount] = useState(0);
    const [active, setActive] =useState(null);
    const [index, setIndex] = useState(-1);
    const [openCase,setOpenCase] =useState(false);

    const [selectedParty, setSelectedParty] =useState(null);

    const [caseParties, setCaseParties] = useState([]);
    const [template, setTemplate] = useState(null); 
    
    const [doc, setDoc] =useState(null)
    const [docline, setDocline] = useState(null);
    const [uplinetype, setUplinetype] = useState('attest');
    const [servedon, setServedOn] = useState(null);
    const [sFile, setSFile] =useState(null);
   
    const [previewPath, setPreviewPath] = useState(false);  
   
    
    const [claimants, setClaimants] = useState('');
    const [defendants, setDefendants] = useState('');
    const [autoFill, setAutoFill] = useState([]); //this is to hold the auto fill items
    const [tab, setTab] = useState('pending');
    const [otherAlert, setOtherAlert]=useState({open:false})

    const [warrant, setWarrant] = useState(null);
    const [warrants, setWarrants]= useState([]);
    const [doclines, setDoclines]=useState([]);
    const [isItems, setIsItems] = useState(false);
    const [isReport, setIsReport] = useState(false);
    const [collectedItems, setCollectedItems] = useState([]);
const [selectedWarrant, setSelectedWarrant] = useState(null);
 const [removingIndex, setRemovingIndex] = useState(null);
const [comData, setComData]=useState(null);
const [option, setOption] = useState(null);

    useEffect(() => {
      if(search!=null){
         if(pageIndex>=0){
           onSearch(search);
         }else{
            setPageIndex(0);
          }
      }
      
        onLoadTemplate();
      
          
    }, [pageIndex,pageSize,tab]);


       useEffect(() => {
      
        if( active!=null){
          //load the parties to the case
          onLoadParties(active.case?.caseId);
         // onLoadWarrants(active.case?.caseId, active.id)
          onLoadSelectedWarrant(active.id)
      
        }            
    }, [active]);

    const IsDefendant=(ptid)=>{
        const v = Constants.getItemById(frequentData.partyTypes,ptid).isLead;
        var m=v??false
        return !m;
    }



 

   

  useEffect(() => {
    if(template!=null && servedon!=null  ){
      onSaveSelect();
    }         
    }, [template,servedon,uplinetype]);  



  const onSearch=async(sear)=>{ 
            setSearch(sear)       ;
            setLoading(true)
            try {
            
            const resp = await fetch(`${Constants.apiUrl}/filing/auction-completed-cases/${pageIndex}/${pageSize}`, {
                method: 'POST',
                body:JSON.stringify(sear) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
               setCases(data.items)
                if(pageIndex==0){
                setCount(data.totalCount)
               }
            }
             else if(data.code==-10){
                      setIsExpired(true);
                  }
                  else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
        }

const onLoadParties= async(caseid)=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/loadparties/${caseid}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                
              setCaseParties(data.parties);
              let claim=''; let defe='';
              data.parties.forEach(element => {
                if(IsDefendant(element.partyTypeId)){
                  
                  defe=defe+`${element.firstName} ${element.lastName??''},`
                  console.log(`in defendant loop ${defe}`)
                }else{
                  
                  claim=claim+`${element.firstName} ${element.lastName??''},`
                  console.log(`in claimant loop ${claim}`)
                }
              });
              setDefendants(defe);
              setClaimants(claim);
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
        const onLoadSelectedWarrant= async(writid)=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/get-warrantline-details-all/${writid}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                
            setCollectedItems(data.collected);
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
    const onLoadTemplate= async()=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/load-special-template/warrant-execution-report`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                
              setTemplate(data.temp);
              
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }    
    
    const onPagePick=(pick)=>{
    console.log('this is selection value');
    setPageIndex(pick.id-1)
    console.log(pick)
  }

    const onContinue=(item,ind)=>{
        //navigate(`/case-details/${caseid}`)
        const division=Constants.getItemById(frequentData?.divisions,item.case.divisionId)?.title
        var _item={...item, 
          division,
       caseType: item.case?.caseFilingId==1?'litigation':'adr',type:'document' }
        setActive(_item);
        console.log(`on continue ${division}`)
        console.log(_item);
        setIndex(ind);
        setOpenCase(true);
    }

    const onCloseOpenCase=()=>{
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
    }

    const onCloseEntries=()=>{
      setActive(null);
      setIsItems(false)
      setIndex(-1);
      setWarrant(null);
        setWarrants(null);
        setDoclines(null);
 
    }
    const onCollectItems=(item,ind)=>{
      setIndex(ind);
      setActive(item);
      setIsItems(true)
    }
    const onSheriffReport=(item,ind)=>{
        //navigate(`/case-details/${caseid}`)
      
        setActive(item);
        setIndex(ind);
        setIsReport(true);
    }
   const onSelectWarrant=(opt)=>{
    setSelectedWarrant(opt);
   }

 const onSaveSelect=async()=>{

        
              
            setLoading(true)
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/filing/save-service-sherif-substituted/select`, {
                method: 'POST',
              //  body:JSON.stringify(select) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
          
            if(data.code==0){
            //update the field
               
                
            } else if(data.code==-10){
                setIsExpired(true);
            }else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
       } 


 const handleUploadChange =async (e) => {
 
        const files = e.target.files;
        console.log(files[0]);
        var b64=await Constants.toBase64(files[0]);
        var path =URL.createObjectURL(files[0]);
        var fname=Constants.ReduceFilename(files[0]?.name);

       var a={ path, base64:b64.split(',')[1],filename: fname, base64Ext:b64.split(',')[0]};

       setSFile(a);
      
    };
const onPreview=(obj)=>{
        setIsPreview(true);
        setPreviewPath(obj.path);
     }





  const onChangeCollected = (index, key, value) => {
  setCollectedItems(prev =>
    prev.map((item, i) => i === index ? { ...item, [key]: value } : item)
  );
};

const onRemoveCollected = async (index) => {
    if(collectedItems.length==1){
        return;
    }

    /* const h=claims[index];
        if(h && h.id>0){
            await onRemoveClaim_Server(h.id);
        } */
     setRemovingIndex(index);
  setTimeout(() => {
    setCollectedItems(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

 
};

const onVerifyCollection=async(e)=>{
             e.preventDefault();

         
 var approve={...option,
            writId:active.id,
            collecteds: collectedItems,
            
           };
            
            setLoading(true)
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/filing/save-warrant-auction/${active.id}`, {
                method: 'POST',
                body:JSON.stringify(approve) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
                setIsItems(false)
                const ft=cases.filter((_, i) => i !== index)
                setCases(ft );
               setAlert({open:true, title:'Clear Case', subtitle:'Case moved to Chief Judge successfully'});
                
            } else if(data.code==-10){
                setIsExpired(true);
            }else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
       } 


const onOptionChange = (e) => {
    setOption({...option, [e.target.name]: e.target.value})
}

  return (
    <div>
     
      <CaseSearch onSearch={onSearch} frequentData={frequentData} />

      <div className='tab_body'>
<div className='tab_section'>
     
        </div>
        <div className='tab_view'>
{cases?.length==0 && <JisEmptyList/>}
{cases?.length>0 && 
<div className='table'>
  <div class="section-cases">
  <span>Execution Sherrif </span>
</div>
      <table class="case-table">
  <thead>
    <tr>
      <th className="col-title">Suit Number</th>
      <th className="col-title">Case Title</th>
      <th className="col-medium">Filing Type</th>
      <th className="col-medium">Classification</th>
      <th className="col-medium">Date Initiated</th>
      <th className="col-medium">Status Level</th>
   <th>SLA</th>
      <th className="col-title">Details</th>
     { <th className="col-action">Action</th>} 
     
    </tr>
  </thead>
  <tbody>
     {cases?.map((opt, index) => {

      return (
      <tr key={index}>
            <td style={{backgroundColor:`${Constants.getItemById(frequentData?.casecategories,opt?.case?.caseCategoryId)?.colour}`}}>{opt?.case?.caseNumber}</td>
      <td >{opt.case?.caseTitle}</td>
       <td>{Constants.getItemById(frequentData?.casetype,opt?.case?.caseTypeId)?.caseType1}</td>
      <td> {Constants.getItemById(frequentData?.casecategories,opt?.case?.caseCategoryId)?.categoryTitle}</td>
      <td> {Constants.momentDate(opt?.case?.createdOn).format('DD MMM, YYYY')}</td>
      <td>{Constants.getItemById(frequentData?.casestatuses,opt?.caseStatusId)?.description}</td>
      <td><DeadlineBadge dateString={opt?.slaExpire}/> </td>
      <td><JisButton variant='plain' onClick={()=>onContinue(opt,index)}>View</JisButton></td>
     <td><JisButton variant='plain' onClick={()=>onCollectItems(opt,index)}>Settlement</JisButton></td>
     
      
    </tr>
    )})} 
    


  </tbody>
</table>
{cases?.length>0 && <Pagenated onChangePageSize={(k)=>setPageSize(k)} size={pageSize} total={count} maxPage={20}  onPick={onPagePick}/>}    
</div>}
        </div>
      </div>

<BackLoader open={loading} />
{otherAlert.open && <JisAlert {...otherAlert} />}
  {openCase && active!=null && <JisDialogForm title="Case Info" onClose={onCloseOpenCase}>
    <div>
      <CaseDetails  caseId={active.caseId} data={null} token={token} initialtab="casedocuments" />
    </div>
    </JisDialogForm> }

   {isItems && active!=null && <JisDialogForm title="Entered Collected Items" onClose={onCloseEntries}>
    <div>
<form onSubmit={onVerifyCollection}> 
     
      
        <div>Auction Items</div>

        {  <div className='view'>
       
            {collectedItems.map((collected, index) => (
            <div key={index} className={`claim-item ${removingIndex === index ? 'removing' : ''}`}>
                <div style={{ flex: 1, display:'flex' }}>
                <div style={{flex:1}}>
                    <div>{collected.itemTitle}</div>
                    <div>{collected.itemDesc}</div>
                    <div>Qty: {collected.itemQty}</div>
                    <div>Type: {collected.itemType}</div>
                </div>
                    <div style={{flex:1}}>
                        <div style={{fontSize:20}}>Auction Amount: {collected.auctionedAmount}</div>
                        <div>Winner(s): collected.winner</div>
                    </div>
                
                    
                 

                </div>
              
            </div>
        ))}
       
        </div>}


<JisCheckbox label="Check If you have completed the Aution" value={option?.isFinalized} onChange={(e) => setOption({...option,isFinalized:e})}
                />
        <div  className="input-group">
            <label>Comment <span className="required">*</span> </label>
            <div className='input-wrapper'>
                <DynamicIcon iname="group" />
                <textarea placeholder=' Comment' name='comment' required={true}  value={option?.comment}
        onChange={onOptionChange}  />
            </div>
        </div> 
  <div className='flowbuttongroup'>
                        
                        <JisButton type='submit' loading={loading}>Save Auction Data</JisButton>
                    </div> 
       {err!='' && <div className='error'>{err}</div>}             
</form>
    </div>
    </JisDialogForm> } 

 
    </div>
  );
}

export default AuctionCompletedCases;